import { isThreeEM, real_id } from 'src/helpers/interface_helpers';
import { convert, convertCost } from 'src/helpers/utilities';
import type { Device } from 'src/types/Device';
import type {
	MonthlyReport,
	MonthlyReportByDevice,
	MonthlyReportConsumption,
} from 'src/types/requests/charts/get_stats_period';

export let data_check = (arr) => {
	let disable;
	arr.forEach((d) => {
		disable = d.available ? false : true;
	});
	return disable;
};

export const getMonthlyTotal = (
	report: MonthlyReport,
	currency: string,
): {
	total: string;
	totalReversed: string;
	cost: number;
	convertCost: string;
} => {
	let consumption = 0,
		cost = 0,
		reversed = 0;
	for (const key in report) {
		const data: MonthlyReportConsumption = report[key];
		consumption += data.consumption;
		cost += data.cost;
		reversed += data.reversed;
	}
	const unit = 'Wh';
	return {
		total: convert(consumption, unit),
		cost,
		convertCost: convertCost(cost, currency),
		totalReversed: convert(reversed, unit),
	};
};

export const getMonthlyReportByDevices = (
	dataSet: MonthlyReportByDevice[],
	devices: { [key: string]: Device },
): MonthlyReportByDevice[] => {
	const dataSetObj = {};
	if (!dataSet || dataSet.length === 0) return [];
	for (let i = 0; i < dataSet.length; ++i) {
		const item = dataSet[i],
			id = item.id,
			realID = real_id(id),
			device = devices[realID];
		if (isThreeEM(device?.type) && device?.mode != 'monophase') {
			if (dataSetObj[realID]) {
				dataSetObj[realID].consumption += item.consumption;
				dataSetObj[realID].cost += item.cost;
				if (!dataSetObj[realID].reversed) dataSetObj[realID].reversed = 0;
				dataSetObj[realID].reversed += item.reversed || 0;
			} else {
				dataSetObj[realID] = { ...item, id: realID };
			}
		} else {
			dataSetObj[id] = item;
		}
	}
	return Object.values(dataSetObj);
};

export const getMonthlyReportByPeakPower = (
	dataSet: any[],
	devices: { [key: string]: Device },
): MonthlyReportByDevice[] => {
	const dataSetObj = {};
	for (let i = 0; i < dataSet?.length; ++i) {
		const item = dataSet[i],
			id = item.id;
		if (Array.isArray(item.peak)) {
			const realID = real_id(id);
			const device = devices[realID];
			if (isThreeEM(device?.type) && device?.mode != 'monophase') {
				let consumption = 0;
				let reversed = 0;
				dataSetObj[realID] = {
					id: realID,
					consumption: 0,
					reversed: 0,
					time: 0,
				};
				for (let p = 0; p < item.peak.length; ++p) {
					consumption += item.peak[p].c;
					reversed += Math.abs(item.peak[p].r);
					dataSetObj[realID].time = item.peak[p].t;
				}
				dataSetObj[realID].consumption = consumption >= reversed ? consumption : 0;
				dataSetObj[realID].reversed = reversed >= consumption ? reversed : 0;
			} else {
				for (let p = 0; p < item.peak.length; ++p) {
					dataSetObj[id] = {
						id,
						consumption: 0,
						reversed: 0,
						time: 0,
					};
					const consumption = item.peak[p].c >= Math.abs(item.peak[p].r) ? item.peak[p].c : 0;
					const reversed =
						Math.abs(item.peak[p].r) >= item.peak[p].c ? Math.abs(item.peak[p].r) : 0;
					dataSetObj[id].consumption = consumption;
					dataSetObj[id].reversed = reversed;
					dataSetObj[id].time = item.peak[p].t;
				}
			}
		} else {
			const consumption = item.peak.c >= Math.abs(item.peak.r) ? item.peak.c : 0;
			const reversed = Math.abs(item.peak.r) >= item.peak.c ? Math.abs(item.peak.r) : 0;
			dataSetObj[id] = { id, consumption, reversed, time: item.peak.t };
		}
	}
	return Object.values(dataSetObj);
};
